// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import moment from 'moment'

import {
  validateDateFormat,
  validateDateIsValid,
} from 'validators/common/sync/date'

// v here is a string
const validDateValue = v => {
  const m = moment(v, 'YYYY/MM/DD')
  return (
    validateDateFormat(v) ||
    v.length && validateDateIsValid(m)
  )
}

export default validDateValue
